module.exports = __webpack_public_path__ + "img/dealing_curio.d66567f5.jpg";